import React, { FC, useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { Element } from "../../../../models/elementModel";
import { useDispatch, useSelector } from "react-redux";
import { getSession } from "../../../../selectors/appSelectors";
import { Tooltip } from "react-tippy";
import { startApplyRule } from "../../../../actions/ruleAction";
import imageService from "../../../../services/imageService";

export interface CarouselElementProps {
  index: string;
  element: Element;
  isPreview?: boolean;
}

const CarouselElement: FC<CarouselElementProps> = ({
  index,
  element,
  isPreview = false,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [addImage, setAddImage] = useState(0);
  const sessionState = useSelector(getSession);
  const [viewRemark, setViewRemark] = useState(sessionState.viewRemark);
  const [open, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const [images, setImages] = useState([]);

  useEffect(() => {
    setViewRemark(sessionState.viewRemark);
    fetchAndDisplayCarouselImages();
  }, [sessionState]);

  // useEffect(() => {
  //   fetchAndDisplayCarouselImages();
  //   console.log("images: ", images);
  // }, []);

  const handleSelect = (selectedIndex: number) => {
    setActiveIndex(selectedIndex);
  };

  // const [onClickActions, setOnClickActions] = useState(
  //   element.actions.filter((action) => {
  //     return action.actionType === "onClick";
  //   })
  // );

  // async function OnClickActions() {
  //   await Promise.all(
  //     onClickActions.map(async (action) => {
  //       dispatch(startApplyRule(action));
  //     })
  //   );
  // }

  const defaultStyle = {
    marginTop: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginTop + "px",
    marginRight: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginRight + "px",
    marginBottom: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginBottom + "px",
    marginLeft: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginLeft + "px",
    textAlign: element.styles.textAlign,
  };

  //custome css lbl - start
  const styleList = element.properties.cssStyles;

  const styleObj: { [key: string]: any } = {};

  if (styleList !== undefined) {
    for (let index = 0; index < styleList.length; index++) {
      styleObj[styleList[index].retrivedStyle] = styleList[index].value;
    }
  }
  //custome css lbl - end

  const heightAndWidth = {
    height:
      element.styles.height === "" ||
      element.styles.height === undefined ||
      element.styles.height === "0"
        ? ""
        : element.styles.height + "px",
    width:
      element.styles.width === "" ||
      element.styles.width === undefined ||
      element.styles.width === "0"
        ? ""
        : element.styles.width + "px",
    // fontSize:
    //   element.styles.fontSize === "" ||
    //   element.styles.fontSize === undefined ||
    //   element.styles.fontSize === "0"
    //     ? ""
    //     : element.styles.fontSize + "pt",
    // color: element.styles.color,
    // ...styleObj,
  };

  async function fetchAndDisplayCarouselImages() {
    try {
      const carouselImages = await imageService.getCarouselImages();

      if (carouselImages) {
        console.log("There is a image for carousel");
        setImages(carouselImages);
        console.log("Images for carousel: ", images);
      } else {
        console.error("Failed to fetch carousel images");
      }
    } catch (error) {
      console.error("Error fetching carousel images:", error);
    }
  }

  let renderImages;

  if (images.length > 0) {
    renderImages = images.map((imageUrl: any, index) => (
      <Carousel.Item key={index}>
        <img
          className="d-block w-100"
          src={imageUrl}
          alt={`Slide ${index + 1}`}
        />
      </Carousel.Item>
    ));
  } else {
    renderImages = (
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://img.freepik.com/free-photo/painting-mountain-lake-with-mountain-background_188544-9126.jpg"
          alt="Default Slide"
        />
        <Carousel.Caption>
          <h3>Select images for carousel</h3>
        </Carousel.Caption>
      </Carousel.Item>
    );
  }

  return (
    <div key={index} style={{ ...defaultStyle, ...heightAndWidth }}>
      <Tooltip title={element.properties.tooltip}>
        <Carousel activeIndex={activeIndex} onSelect={handleSelect}>
          {renderImages}
          {/* <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://img.freepik.com/free-photo/painting-mountain-lake-with-mountain-background_188544-9126.jpg"
              alt="First slide"
            />
            <Carousel.Caption>
              <h3>First slide label</h3>
              <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
            </Carousel.Caption>
          </Carousel.Item>
          */}
        </Carousel>
      </Tooltip>

      {isPreview &&
        viewRemark &&
        (element.properties.remark1 ||
          element.properties.remark2 ||
          element.properties.remark3 ||
          element.properties.remark4) && (
          <Tooltip
            interactive
            open={open}
            onRequestClose={() => setIsOpen(false)}
            html={
              <>
                <h6>Remarks of {element.name}</h6>
                {element.properties.remark1 !== undefined &&
                  element.properties.remark1 !== "" && (
                    <div className="remark">
                      Remark 1 : {element.properties.remark1}
                    </div>
                  )}
                {element.properties.remark2 !== undefined &&
                  element.properties.remark2 !== "" && (
                    <div className="remark">
                      Remark 2 : {element.properties.remark2}
                    </div>
                  )}
                {element.properties.remark3 !== undefined &&
                  element.properties.remark3 !== "" && (
                    <div className="remark">
                      Remark 3 : {element.properties.remark3}
                    </div>
                  )}
                {element.properties.remark4 !== undefined &&
                  element.properties.remark4 !== "" && (
                    <div className="remark">
                      Remark 4 : {element.properties.remark4}
                    </div>
                  )}
                {(element.properties.remark1 === undefined ||
                  element.properties.remark1 === "") &&
                  (element.properties.remark2 === undefined ||
                    element.properties.remark2 === "") &&
                  (element.properties.remark3 === undefined ||
                    element.properties.remark3 === "") &&
                  (element.properties.remark4 === undefined ||
                    element.properties.remark4 === "") && (
                    <div>No Remarks to Display</div>
                  )}
              </>
            }
            position="left"
          >
            <div style={{ textAlign: "end" }}>
              <i
                className="fa fa-info-circle"
                aria-hidden="true"
                onClick={() => {
                  setIsOpen(true);
                }}
              ></i>
            </div>
          </Tooltip>
        )}
    </div>
  );
};

export default CarouselElement;
